import Enum from "../../../enums/Enum";

const EnumRestrictionType = new Enum({
    ALL: "All",
    ALL_FEMALES: "All females",
    ALL_MALES: "All males",
    STAFF: "Providers",
    DEPARTMENT: "Department"
});

export default EnumRestrictionType;